import React, { useState  , useEffect} from 'react';
import SplashScreen from '../shared/splashScreen/splashScreen';
import Home from './home/home';
import DetailSection from '../detailSection/detailSection';
import Content from './content/content';
import DeliveriesCount from './deliveriesCount/deliveriesCount';
import WorkProcess from './workProcess/workProcess';
import DeliveryCities from './deliveryCities/deliveryCities';
import Partner from '../shared/partners/partner';
import WatchAction from './watchAction/watchAction';
import Questions from '../shared/questions/questions';
import Footer from '../shared/footer/footer';
import useGetdata from '../../Hooks/useGetData';
import SnackbarNav from './SnackbarNav/SnackbarNav';
import useIsMobile from '../../Hooks/useIsMobile';
import '../../components/main/main.css'
import MobileMenu from './SnackbarNav/MobileMenu';
// import ScrollManager from '../../Utils/ScrollManager';
const Main = () => {
  const isMobile = useIsMobile();
  const [menuOpen, setMenuOpen] = useState(false);
   useGetdata();
  const [showSplash, setShowSplash] = useState(() => {
    return sessionStorage.getItem('splashShown') !== 'true';
  });

  const handleSplashFinish = () => {
    sessionStorage.setItem('splashShown', 'true');
    setShowSplash(false);
  };

  if (showSplash) {
    return <SplashScreen onFinish={handleSplashFinish} />;
  }

  return (
    <main className="website-page-wrapper">
       {/* <ScrollManager delay={700} /> */}
      <section id="home">
        <Home />
      </section>
      <section>
      {!isMobile && <SnackbarNav />}
      {isMobile && !menuOpen && (
        <button className="menu-toggle" onClick={() => setMenuOpen(true)}>
          ☰
        </button>
      )}
       {isMobile && menuOpen && (
        <MobileMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
      )}
      </section>

      <section id="deliveriesCount">
        <DeliveriesCount />
      </section>

      <section id="content">
        <Content />
      </section>

      <section id="workProcess">
        <WorkProcess />
      </section>

      <section id="deliveryCities">
        <DeliveryCities />
      </section>

      <section id="partner">
        <Partner />
      </section>

      <section id="watchAction">
        <WatchAction />
      </section>

      <section id="questions">
        <Questions />
      </section>

      <section id="footer">
        <Footer />
      </section>
    </main>
  );
};

export default Main;
